import React, { useMemo, useState } from 'react';
import { connect, useIntl } from 'umi';
import { Layout, Row, Col } from 'tea-component';
import VersionDailyFilter from '../../filterPageComponents/overview/versionDailyFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import OverviewTable from '@/pages/dashboard/pages/overview/components/OverviewTable';
import { useBuriedPoint } from '@/pages/home/utils/customHook';
import MarqueeInfo from '@/pages/dashboard/components/MarqueeInfo';

import '@/pages/dashboard/assets/scss/page/Overlay/index.scss';
import OverviewVersionTable from './components/OverviewVersionTable';
import OperationList from '../../components/PageContainer/OperationList';
import { SubTitle } from '@/pages/dashboard/components/SubTitle';
import { SYSTEM_PERMISSIONS_MAP } from '@/pages/dashboard/_config/constant';

const { Content } = Layout;

const Daily = (props: any) => {
  const { gameCode, explainInfo, gameConfig, userInfo } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const [formValue, setFormValue] = useState<any>({
    filterValue: null,
    newFilter: true,
    timeType: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: true,
  });
  const [filterLoading, setFilterLoading] = useState(true);

  // 打点
  const logObj = {
    pageId: '203001',
    pageName: 'Daily-版本汇总',
    extInfo: 'Daily-版本汇总',
    pagePath: '/overview/versionDaily',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };

  useBuriedPoint(logObj);

  const handleConfirm = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
  };

  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
    setFilterLoading(false);
  };

  // 头部操作按钮跟系统权限关联
  const operationList = useMemo(() => {
    // 用户权限
    const permissions = userInfo?.permissions ? Object.keys(userInfo?.permissions || {}) : [];
    // 操作按钮组配置
    const operationList = [
      {
        nameEn: '情报',
        nameCn: 'Intelligence',
        url: (data: any) => {
          const { unifiedid } = data;
          return `/intelligence/topCharts/mobileGames/gamesDetails/${unifiedid}`;
        },
        show: permissions?.includes(SYSTEM_PERMISSIONS_MAP?.Intelligence)
      },
      {
        nameEn: '舆情',
        nameCn: 'Opinions',
        url: '/opinion/Overview',
        params: { gameid: 'unifiedid' },
        permission: 'hasOpinionPermissions',
        show: permissions?.includes(SYSTEM_PERMISSIONS_MAP?.Opinions)
      }
    ];
    return operationList;
  }, [userInfo?.permissions]);

  return (
    <Content className="dbd-scroll-body">
      <Content.Header
        title={
          <div className="page-title">
            {formatMessage({ id: 'overview_daily_Daily' })}
          </div>
        }
        subtitle={<SubTitle/>}
        operation={
          <>
            <OperationList data={{...gameConfig}} operationList={operationList}/>
          </>
        }
      ></Content.Header>
      <Content.Body full>
        <MarqueeInfo pagePath={'/overview/versionDaily'} />
        <VersionDailyFilter
          openSticky={true}
          formValue={formValue}
          filterConfirm={handleConfirm}
          filterReset={handleConfirm}
          buttonLogConfig={{
            pageId: '203001',
            confirmButtonId: '203001001',
            resetButtonId: '203001002',
          }}
          filterLoading={filterLoading}
          setFilterLoading={setFilterLoading}
          filterInit={handleInit}
        />
        <Row className="margin-t-10">
          <Col>
            <OverviewVersionTable
              filterValue={formValue}
              filterLoading={filterLoading}
              gameCode={gameCode}
              explainInfo={explainInfo}
            />
          </Col>
        </Row>
        <Row className="margin-t-10">
          <Col>
            <OverviewTable
              tableType='day'
              filterValue={formValue}
              filterLoading={filterLoading}
              gameConfig={gameConfig}
              gameCode={gameCode}
              explainInfo={explainInfo}
            />
          </Col>
        </Row>
      </Content.Body>
    </Content>
  );
};

export default connect((state: any) => ({
  serviceData: state.overview?.data,
  gameCode: state.dashboard?.currentGame?.game_code,
  gameConfig: state.dashboardSetting?.gameConfig,
  explainInfo: state.dashboard?.explainInfo,
  userInfo: state?.home?.userInfo,
}))(Daily);
